export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8028.27fb4edb.jpg";